import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "../data/site";
import { FadeUp, SectionHead, EASE } from "./motion";
import { useLang } from "../context/LangContext";

export const Manifesto = () => {
  const { S } = useLang();
  return (
    <section id="pourquoi" data-testid="pourquoi-section" className="relative bg-[#0A182E] py-24 lg:py-32 overflow-hidden grain">
      <div
        className="absolute -top-40 -right-40 w-[560px] h-[560px] rounded-full bg-sky-600/10 blur-3xl"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <SectionHead
              dark
              eyebrow={S.manifesto.eyebrow}
              title={S.manifesto.title}
              subtitle={S.manifesto.subtitle}
            />
            <FadeUp delay={0.24}>
              <a
                href="#devis"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId("#devis");
                }}
                data-testid="pourquoi-cta-devis"
                className="group mt-10 inline-flex items-center gap-3 rounded-full bg-sky-600 px-7 py-3.5 text-sm font-semibold text-white shadow-xl shadow-sky-950/40 transition-all duration-300 hover:bg-sky-500 hover:-translate-y-0.5"
              >
                {S.manifesto.cta}
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </FadeUp>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-x-10">
            {S.manifesto.items.map((a, i) => (
              <motion.div
                key={a.num}
                data-testid={`avantage-${a.num}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: EASE }}
                className="group border-t border-white/10 py-7 transition-colors duration-500 hover:border-sky-500/60"
              >
                <span className="font-tech text-sm font-semibold text-sky-400 tracking-widest">{a.num}</span>
                <h3 className="mt-3 font-display text-lg font-semibold tracking-tight text-white">{a.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{a.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
